import { render, staticRenderFns } from "./FreeCoursesGrid.vue?vue&type=template&id=105e091e"
import script from "./FreeCoursesGrid.vue?vue&type=script&lang=js"
export * from "./FreeCoursesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports